<template>
  <div>
    <v-layout row wrap>
      <v-tabs v-model="polTabs" icons-and-text>
        <v-tab @click="doTab(0)">Group Details<v-icon color="cyan">mdi-group</v-icon></v-tab>
        <v-tab @click="doTab(1)">Risk Details<v-icon color="cyan">mdi-pencil-box-outline</v-icon></v-tab>
        <v-tab @click="doTab(2)">Coverage<v-icon color="cyan">mdi-format-list-bulleted</v-icon></v-tab>
        <v-tab @click="doTab(3)">Trailer<v-icon color="cyan">mdi-history</v-icon></v-tab>
      </v-tabs>
    </v-layout>
    <v-container fluid grid-list-sm>
      <v-flex xs12>
        <router-view ref="childComponent"></router-view>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headers: 0,
      polTabs: 0,
      hideSlider: undefined
    }
  },
  props: {
    functionId: String
  },
  methods: {
    doInit() {
      this.polTabs = 0
      this.doTab(0)
    },
    tabClass(index) {
      if (this.headers === index) {
        return 'tabCard tabActive'
      } else {
        return 'tabCard'
      }
    },
    doTab(index) {
      this.headers = index
      if (this.functionId === 'undoPolicyRelease') {
        if (index === 0) {
          this.$router.push({ name: 'undoPolicyGroup' }).catch(() => {})
        } else if (index === 1) {
          this.$router.push({ name: 'undoPolicyRisk' }).catch(() => {})
        } else if (index === 2) {
          this.$router.push({ name: 'undoPolicyCoverage' }).catch(() => {})
        } else if (index === 3) {
          this.$router.push({ name: 'undoPolicyRiskTrailer' }).catch(() => {})
        }
      } else if (this.functionId === 'deleteUnReleasePolicy') {
        if (index === 0) {
          this.$router.push({ name: 'deletePolicyGroup' }).catch(() => {})
        } else if (index === 1) {
          this.$router.push({ name: 'deletePolicyRisk' }).catch(() => {})
        } else if (index === 2) {
          this.$router.push({ name: 'deletePolicyCoverage' }).catch(() => {})
        } else if (index === 3) {
          this.$router.push({ name: 'deletePolicyRiskTrailer' }).catch(() => {})
        }
      } else {
        if (index === 0) {
          this.$router.push({ name: 'queryPolicyGroup' }).catch(() => {})
        } else if (index === 1) {
          this.$router.push({ name: 'queryPolicyRisk' }).catch(() => {})
        } else if (index === 2) {
          this.$router.push({ name: 'queryPolicyCoverage' }).catch(() => {})
        } else if (index === 3) {
          this.$router.push({ name: 'queryPolicyRiskTrailer' }).catch(() => {})
        }
      }
    }
  },
  beforeMount() {
    // this.$router.push({ name: 'queryPolicyGroup' })
    this.doInit()
  }
}
</script>

<style lang="scss">
@import '../../../../../assets/scss/underwriting.scss';
</style>
